import { AwardsDialog } from "../pages/builder/sidebar/dialogs/awards";
import { CertificationsDialog } from "../pages/builder/sidebar/dialogs/certifications";
import { CustomSectionDialog } from "../pages/builder/sidebar/dialogs/custom-section";
import { EducationDialog } from "../pages/builder/sidebar/dialogs/education";
import { ExperienceDialog } from "../pages/builder/sidebar/dialogs/experience";
import { InterestsDialog } from "../pages/builder/sidebar/dialogs/interests";
import { LanguagesDialog } from "../pages/builder/sidebar/dialogs/languages";
import { OptimizationQuestionsDialog } from "../pages/builder/sidebar/dialogs/optimization-questions";
import { ProfilesDialog } from "../pages/builder/sidebar/dialogs/profiles";
import { ProjectsDialog } from "../pages/builder/sidebar/dialogs/projects";
import { PublicationsDialog } from "../pages/builder/sidebar/dialogs/publications";
import { ReferencesDialog } from "../pages/builder/sidebar/dialogs/references";
import { SkillsDialog } from "../pages/builder/sidebar/dialogs/skills";
import { VolunteerDialog } from "../pages/builder/sidebar/dialogs/volunteer";
import { ImportDialog } from "../pages/dashboard/resumes/_dialogs/import";
import { LockDialog } from "../pages/dashboard/resumes/_dialogs/lock";
import { ResumeDialog } from "../pages/dashboard/resumes/_dialogs/resume";
import { TwoFactorDialog } from "../pages/dashboard/settings/_dialogs/two-factor";
import { useResumeStore } from "../stores/resume";

type Props = {
  children: React.ReactNode;
};

export const DialogProvider = ({ children }: Props) => {
  const isResumeLoaded = useResumeStore((state) => Object.keys(state.resume).length > 0);

  return (
    <>
      {children}

      <div id="dialog-root">
        <ResumeDialog />
        <LockDialog />
        <ImportDialog />
        <TwoFactorDialog />

        {isResumeLoaded && (
          <>
            <ProfilesDialog />
            <ExperienceDialog />
            <EducationDialog />
            <AwardsDialog />
            <CertificationsDialog />
            <InterestsDialog />
            <LanguagesDialog />
            <ProjectsDialog />
            <PublicationsDialog />
            <VolunteerDialog />
            <SkillsDialog />
            <ReferencesDialog />
            <CustomSectionDialog />
            <OptimizationQuestionsDialog />
          </>
        )}
      </div>
    </>
  );
};
